var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 92,
    viewBox: "0 0 131 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.9005 79.3654H80.0948V82.3857H50.9005V79.3654Z",
    fill: "#40336F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7763 84.7209C84.7763 86.0109 83.73 87.0568 82.437 87.0568H48.563C47.27 87.0568 46.2237 86.0109 46.2237 84.7209V79.3649H0V79.39C0 86.3428 5.66546 92 12.6285 92H118.372C125.335 92 131 86.3428 131 79.39V79.3649H84.7763V84.7209Z",
    fill: "#40336F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2757 6.86731V74.693H119.733V6.86731C119.733 3.08065 116.646 0 112.854 0H18.1542C14.362 0 11.2757 3.08065 11.2757 6.86731Z",
    fill: "#40336F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.e94516abba46f8711f54dcc81a07f41b.svg";
export { ForwardRef as ReactComponent };